<script>
import LineChart from '@/components/charts/LineChart.js';
import TrackerLegend from '@/components/patient/detail/TrackerLegend.vue';
import chartSvc from '@/services/chartSvc.js';
import _ from 'lodash';

export default {
  name: 'PatientTracker',
  components: {
    LineChart,
    TrackerLegend
  },
  props: [ 'trackerHistory' ],
  render(createElement) {
    if (this.trackerHistory && this.trackerHistory.length > 0) {
      const chartOptions = this.chartOptions;
      const emotionalTracker = this.trackerHistory.filter((k) => k.title === 'Emotional Health');
      let trackers = this.getTrackerObject(emotionalTracker);

      return createElement('section', [
        createElement('h2', { class: 'heading' }, 'Tracker History'),
        Object.keys(trackers).map(function(k) {
          return createElement('section', { class: 'chart' }, [
            createElement(LineChart, {
              props: {
                options: chartOptions,
                chartData: trackers[k].chartData,
                width: 400,
                height: 320,
                cssClasses: 'chart-wrapper'
              }
            }),
            createElement(TrackerLegend, {
              props: {
                ceilingLabel: trackers[k].ceilingLabel,
                floorLabel: trackers[k].floorLabel
              }
            })
          ]);
        })
      ]);
    } else {
      return createElement('section', [
        createElement('h2', { class: 'heading' }, 'Tracker History'),
        createElement('p', 'No data captured')
      ]);
    }
  },
  methods: {
    getTrackerObject(trackerArray) {
      const settings = this.trackerSettings;
      let result = {};
      _.forEach(trackerArray, function(t) {
        let dataset = chartSvc.createDataset(settings[t.name]);
        dataset.label = t.title;
        dataset.data = _.map(t.trackerEntries, 'mood');
        let labels = chartSvc.getDatesAsLabels(_.map(t.trackerEntries, 'createdOn'));
        result[t.name] = {
          chartData: {
            labels: labels,
            datasets: [dataset]
          },
          ceilingLabel: t.positiveLabel,
          floorLabel: t.negativeLabel
        };
      });
      return result;
    }
  },
  data() {
    return {
      trackerSettings: {
        'login2': {
          backgroundColor: 'rgba(0,124,166,0.2)',
          borderColor: 'rgba(0,124,166,0.9)'
        },
        'alcohol': {
          backgroundColor: 'rgba(253,216,53,0.2)',
          borderColor: 'rgba(253,216,53,0.9)'
        },
        'anxiety': {
          backgroundColor: 'rgba(67,160,71,0.2)',
          borderColor: 'rgba(67,160,71,0.9)'
        },
        'depression': {
          backgroundColor: 'rgba(31,136,229,0.2)',
          borderColor: 'rgba(31,136,229,0.9)'
        },
        'drug': {
          backgroundColor: 'rgba(96,125,139,0.2)',
          borderColor: 'rgba(96,125,139,0.9)'
        },
        'energy': {
          backgroundColor: 'rgba(251,139,2,0.2)',
          borderColor: 'rgba(251,139,2,0.9)'
        },
        'exercise': {
          backgroundColor: 'rgba(2,200,82,0.2)',
          borderColor: 'rgba(2,200,82,0.9)'
        },
        'mania': {
          backgroundColor: 'rgba(216,28,96,0.2)',
          borderColor: 'rgba(216,28,96,0.9)'
        },
        'pain': {
          backgroundColor: 'rgba(141,37,170,0.2)',
          borderColor: 'rgba(141,37,170,0.9)'
        },
        'painimpact': {
          backgroundColor: 'rgba(73,20,139,0.2)',
          borderColor: 'rgba(73,20,139,0.9)'
        },
        'sleep': {
          backgroundColor: 'rgba(57,73,171,0.2)',
          borderColor: 'rgba(57,73,171,0.9)'
        },
        'stress': {
          backgroundColor: 'rgba(229,57,53,0.2)',
          borderColor: 'rgba(229,57,53,0.9)'
        }
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: 0,
              suggestedMax: 100
            }
          }]
        },
        layout: {
          padding: {
            left: 8,
            right: 16
          }
        }
      }
    };
  }
};
</script>

